import React from 'react';

import styled, { css } from 'styled-components';

import { NewTable, RowZ, ColZ, LayoutZ } from '../TableSkeleton/TableSkeleton';
import { Skeleton } from 'fpay-ui';

export const TextHeader = styled(Skeleton)`
  height: 16px;
  width: ${(props) =>
    props.headerDate
      ? '60px'
      : props.headerCode
      ? '45px'
      : props.headerType
      ? '75px'
      : props.headerDetail
      ? '83px'
      : '37px'};
`;

export const TextColumn = styled(Skeleton)(
  ({ theme }) => css`
    height: 20px;
    width: ${(props) => (props.columnDetail ? '112px' : props.columnMount ? '112px' : '102px')};
    ${theme.breakpoint('md')} {
      width: ${(props) =>
        props.columnDate
          ? '39px'
          : props.columnCode
          ? '46px'
          : props.columnType
          ? '89px'
          : props.columnDetail
          ? '117px'
          : props.columnMount
          ? '89px'
          : ''};
    }
    ${theme.breakpoint('ll')} {
      width: ${(props) => (props.columnType ? '117px' : props.columnMount ? '117px' : '')};
    }
  `
);

const TableSkeletonLastMovements = () => {
  return (
    <LayoutZ>
      <NewTable>
        <RowZ header>
          <ColZ>
            <TextHeader headerDate />
          </ColZ>
          <ColZ>
            <TextHeader headerCode />
          </ColZ>
          <ColZ>
            <TextHeader headerType />
          </ColZ>
          <ColZ>
            <TextHeader headerDetail />
          </ColZ>
          <ColZ align="end">
            <TextHeader />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
        <RowZ>
          <ColZ type="title" order="3">
            <TextColumn columnDetail />
          </ColZ>
          <ColZ order="4" type="title" textalign="right" align="right">
            <TextColumn columnMount />
          </ColZ>
          <ColZ order="1">
            <TextColumn columnCode />
          </ColZ>
          <ColZ order="0" textalign="right" date>
            <TextColumn columnDate />
          </ColZ>
          <ColZ order="2" textalign="right" align="left" nodata>
            <TextColumn columnType />
          </ColZ>
        </RowZ>
      </NewTable>
    </LayoutZ>
  );
};

export default TableSkeletonLastMovements;